import { handleActions } from 'redux-actions'
import { Immutable as ImmutableGenericsType } from 'seamless-immutable'

import { initialState, ModalLoaderState } from './model'
import { Payload } from '../../../types'
import { prepareActions } from '../../../utils/redux'

const actionsNames = ['showModalLoader', 'hideModalLoader', 'forceHideModalLoader']

interface Actions {
  showModalLoader: any
  hideModalLoader: any
  forceHideModalLoader: any
}

export const actions: Actions = prepareActions(actionsNames, 'modal_loader') as Actions

type State = ImmutableGenericsType<ModalLoaderState>

export default handleActions<State, Payload>(
  {
    [actions.showModalLoader]: (state, action: any): State => {
      const id: string = action.id as string

      return state.updateIn(['ids'], arr => arr.concat([id]))
    },
    [actions.hideModalLoader]: (state, action): State => {
      if (action.payload) {
        const id: any = action.payload

        if (id) {
          const newIds = state.ids.filter(value => value !== id)
          return state.set('ids', newIds)
        }
      }
      return state
    },
    [actions.forceHideModalLoader]: (state): State => state.set('ids', []),
  },
  initialState
)
